export default "__VITE_ASSET__DEdoN2Zn__"